import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const DocumentViewerPage = () => {
  const { encodedUrl } = useParams();
  const navigate = useNavigate();
  const [documentUrl, setDocumentUrl] = useState(null);
  const [documentType, setDocumentType] = useState(null); // New state to store document type
  const [scale, setScale] = useState(1); // For zoom functionality

  useEffect(() => {
    if (encodedUrl) {
      try {
        const decodedUrl = decodeURIComponent(encodedUrl);
        setDocumentUrl(decodedUrl);

        // Determine document type based on extension
        const fileExtension = decodedUrl.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
          setDocumentType('image');
        } else if (fileExtension === 'pdf') {
          setDocumentType('pdf');
        } else {
          setDocumentType('unsupported'); // Handle other types as unsupported for now
        }

      } catch (e) {
        console.error("Failed to decode URL:", e);
        setDocumentUrl(null);
        setDocumentType(null);
      }
    }
  }, [encodedUrl]);

  const handleZoomIn = () => setScale(prevScale => Math.min(prevScale + 0.1, 3)); // Max zoom 3x
  const handleZoomOut = () => setScale(prevScale => Math.max(prevScale - 0.1, 0.5)); // Min zoom 0.5x
  const handleResetZoom = () => setScale(1);

  if (!documentUrl || !documentType) {
    return (
      <>
        <Header />
        <div id="wrapper" style={{ paddingTop: '70px' }}>
          <div className="content">
            <p className="text-danger">Document not found or invalid URL.</p>
            <button className="btn btn-default" onClick={() => navigate(-1)}>Back</button>
          </div>
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div id="wrapper" style={{ paddingTop: '70px' }}>
        <div className="normalheader">
          <div className="hpanel">
            <div className="panel-body">
              <h2 className="font-light m-b-xs">Document Viewer</h2>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-body">
                  <div className="document-viewer-controls mb-3">
                    <button className="btn btn-default mr-2" onClick={() => navigate(-1)}>Back to Details</button>
                    <button className="btn btn-default mr-2" onClick={handleZoomIn}>Zoom In</button>
                    <button className="btn btn-default mr-2" onClick={handleZoomOut}>Zoom Out</button>
                    <button className="btn btn-default" onClick={handleResetZoom}>Reset Zoom</button>
                  </div>
                  <div style={{
                    overflow: 'auto',
                    maxHeight: 'calc(100vh - 250px)', // Adjust as needed
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                    {documentType === 'image' && (
                      <img
                        src={documentUrl}
                        alt="Document"
                        style={{
                          transform: `scale(${scale})`,
                          transformOrigin: 'center center',
                          maxWidth: '100%', // Ensure it doesn't overflow initially
                          height: 'auto',
                        }}
                      />
                    )}
                    {documentType === 'pdf' && (
                      <iframe
                        src={documentUrl} // Browsers typically have built-in PDF viewers
                        title="Document Viewer"
                        style={{
                          width: '100%',
                          height: 'calc(100vh - 270px)', // Adjust to fit within the container
                          border: 'none',
                        }}
                      ></iframe>
                    )}
                    {documentType === 'unsupported' && (
                      <p className="text-danger">Unsupported document type.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default DocumentViewerPage; 